import { Component, inject, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { addIcons } from "ionicons";
import { close, exitOutline } from "ionicons/icons";
import { ModalController, IonHeader, IonToolbar, IonTitle, IonButtons, IonButton, IonIcon, IonContent, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonInput, IonSpinner } from '@ionic/angular/standalone';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { AuthService } from '../auth.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-invite',
    templateUrl: './invite.page.html',
    styleUrls: ['./invite.page.scss'],
    standalone: true,
    imports: [IonSpinner, IonInput, IonCardContent, IonCardTitle, IonCardHeader, IonCard, IonContent, IonIcon, IonButton, IonButtons, IonTitle, IonToolbar, IonHeader, CommonModule, FormsModule]
})
export class InvitePage implements OnInit {

    private auth = inject(AuthService)
    sent = false
    code = ""
    error: string
    isModal = false
    isMenu = false

    constructor(
        public api: ApiService,
        public modalController: ModalController
    ) {
        addIcons({ exitOutline,close });
    }

    ngOnInit() {
        
    }

    async checkInviteCode() {
        this.error = null
        this.sent = true
        const gres = await this.api.checkInviteCode(this.code)
        if (gres.group && this.isModal) {
            const al = await this.api.presentAlert("Fatto!", "Ora puoi accedere ai contenuti del canale " + gres.group.name)
            await al.onDidDismiss()
            await this.auth.saveSelectedGroup(gres.group)
            window.open("/", "_self")
        }
        else if (gres.group) {

            const gu = await FirebaseAuthentication.getCurrentUser()
            let u = gu.user
            await this.api.updateUserGroup(u.uid, gres.group.gid)
            //this.api.selectedGroup = gres.group
            //this.api.logout()
            window.open("/", "_self")
        } else {
            this.error = "Codice non valido"
            this.code = ""
            this.sent = false
        }
    }

    async logout() {
        await this.auth.logout()
        window.open("/", "_self")
    }
}
